import Vue from 'vue'
import Vuex from 'vuex'

import User from './modules/User'
import Partner from './modules/Partner'
import LoginDomain from './modules/LoginDomain'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    User,
    Partner,
    LoginDomain,
  },
})

export type OmitFirstArg<F> = F extends (x: any, ...args: infer P) => infer R ? (...args: P) => R : never
